import React from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import { Loading } from '@components/common';
import UpdateProvider from './UpdateProvider';

const DashboardHOC = () => (Wrapper) => {
  const DashboardPage = ({
    match,
    dashboard,
    dashboardType,
    response,
    isFetching,
    tempIsFetching,
    getDashboard,
    initDashboard,
    initTempDashboard,
    fetchingAction,
    ...rest
  }) => {
    const id = `${get(match, 'params.id', '')}`;

    React.useEffect(() => {
      initDashboard();
      getDashboard(id);
      return () => fetchingAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const responseId = `${get(response, 'id', '')}`;

    if (isFetching || (responseId && id !== responseId)) {
      return <Loading />;
    }
    return (
      <UpdateProvider
        id={id}
        dashboard={dashboard}
        dashboardType={dashboardType}
        initTempDashboard={initTempDashboard}
        response={response}
        isFetching={tempIsFetching}
      >
        {() => (tempIsFetching ? <Loading /> : <Wrapper id={id} match={match} {...rest} />)}
      </UpdateProvider>
    );
  };

  DashboardPage.defaultProps = {
    response: null,
    tempIsFetching: false,
    fetchingAction: noop,
  };

  return React.memo(DashboardPage);
};

export default DashboardHOC;
